import { useInfiniteQuery } from "@tanstack/react-query";
import { getPropertiesForInterests } from "@/modules/lead-page/api/lead-page.v2.api";
import { useDebounce } from "@/modules/common/hooks/debounce.hook";

interface UsePropertiesForInterestsInfiniteQueryParams {
  leadTypeUid?: string;
  journeyUid?: string;
  search?: string;
  enabled?: boolean;
}

export const usePropertiesForInterestsInfiniteQuery = ({
  leadTypeUid,
  journeyUid,
  search = "",
  enabled,
}: UsePropertiesForInterestsInfiniteQueryParams) => {
  const debouncedSearch = useDebounce(search, 1000);

  const query = useInfiniteQuery({
    queryKey: ["properties-for-interests", debouncedSearch, leadTypeUid],
    queryFn: async ({ pageParam = 1 }) =>
      getPropertiesForInterests({
        leadTypeUid: leadTypeUid ?? "",
        journeyUid: journeyUid ?? "",
        search: debouncedSearch,
        pagination: {
          page: pageParam,
          pageSize: 20,
        },
      }),

    getNextPageParam: (lastPage) => {
      const { page, pageSize, total } = lastPage.data;
      if (!page || !pageSize || total === undefined) return undefined;

      const totalPages = Math.ceil(total / pageSize);
      return page < totalPages ? page + 1 : undefined;
    },
    enabled: enabled ?? Boolean(leadTypeUid && journeyUid),
    select: (data) => {
      const allResults = data.pages.flatMap((p) => p.data.results);
      return {
        ...data,
        results: allResults,
      };
    },
  });

  return query;
};
